import e from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_previous_decade_date.ts
var t = (t) => e(t).subtract(10, "year").format("YYYY-MM-DD");
export { t as get_previous_decade_date };

//# sourceMappingURL=get_previous_decade_date.js.map